module.exports = __webpack_public_path__ + "static/16-f3fd34272f1bb256efca43cc3fface6d.jpg";